export default __webpack_public_path__ + "static/media/outdent-rtl.183d3278.svg";